import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../../commons/services/alert.service';
import { TimeSlots } from '../../../../../../commons/models/timeslots';
import * as TimeSlotsActions from '../../../../../../store/actions/timeslots.actions';


@Component({
  selector: 'app-new-time-slots',
  templateUrl: './new-time-slots.component.html',
  styleUrls: ['./new-time-slots.component.scss']
})
export class NewTimeSlotsComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  timeslotsForm: UntypedFormGroup;
  timeslots: TimeSlots;

  constructor(
    private store$: Store<AppState>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data) {
      this.timeslots = this.data.timeslot;
    }

    this._createForm();
    //console.log("Dati passati al componente:", this.data);
    this.ngOnChanges();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    let timeslotGroup = {
      // start_time: [this.timeslots ? this.timeslots.start_time : "", [Validators.required, Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)]],
      start_time: [this.timeslots ? this._formatTimeForInput(this.timeslots.start_time) : "", [Validators.required]],
      // end_time: [this.timeslots ? this.timeslots.end_time : "", [Validators.required, Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)]],
      end_time: [this.timeslots ? this._formatTimeForInput(this.timeslots.end_time) : "", [Validators.required]],
      day_of_week: [this.timeslots ? this.timeslots.day_of_week : "", [Validators.required, Validators.min(1), Validators.max(7)]],
      active: [this.timeslots ? this.timeslots.active : true]
    };


    this.timeslotsForm = this.fb.group(timeslotGroup);
    this.timeslotsForm.setValidators(this.validateTimes);
  }

  // Converte "hh:mm:ss" in "hh:mm" per il form
  private _formatTimeForInput(time: string): string {
    return time ? time.slice(0, 5) : ""; // Rimuove i secondi
  }

  // Converte "hh:mm" in "hh:mm:ss" per backend solo se necessario
  private _formatTimeForBackend(time: string): string {
    if (!time) return null;

    // Se il tempo è già nel formato hh:mm:ss, non aggiungere ":00"
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
        return time;
    }

    // Se il tempo è nel formato hh:mm, aggiungere ":00"
    if (/^\d{2}:\d{2}$/.test(time)) {
        return `${time}:00`;
    }

    console.error('Formato orario non valido:', time);
    return null;
  }

  private ngOnChanges() {
    if (this.timeslotsForm) {
      this.timeslotsForm.reset();
   
      this._initFormValues(this.timeslots);
    }
  }

  private _initFormValues(timeslots?: TimeSlots) {
    if (timeslots) {
      this.timeslotsForm.patchValue({
        start_time: timeslots.start_time,
        end_time: timeslots.end_time,
        day_of_week: timeslots.day_of_week,
        active: timeslots.active,
        tenant_id: timeslots.tenant_id
      });
    } else {
      this.timeslotsForm.markAllAsTouched();
    }
  }

  private _prepareSaveTimeSlot(): TimeSlots {
    let formValues = { ...this.timeslotsForm.value };

    formValues.start_time = this._formatTimeForBackend(formValues.start_time);
    formValues.end_time = this._formatTimeForBackend(formValues.end_time);

    let timeslotData = TimeSlots.fromFormGroup(this.fb.group(formValues), this.timeslots);
    timeslotData.tenant_id = this.data?.tenant_id;

    return timeslotData;
  }


  validateTimes(formGroup: UntypedFormGroup) {
    const startTime = formGroup.get('start_time').value;
    const endTime = formGroup.get('end_time').value;

    if (startTime && endTime && endTime <= startTime) {
      return { timeError: true };
    }
    return null;
  }


  save() {
    let unsavedEntity = this._prepareSaveTimeSlot();
    this.store$.dispatch(TimeSlotsActions.saveTimeSlot({ timeslots: unsavedEntity }));
  }

  close() {
    if (this.timeslotsForm.dirty) {
          // Se ci sono modifiche, mostra il dialog di conferma
          this.store$.dispatch(TimeSlotsActions.requestCloseTimeSlotsDialog());
        } else {
          // Se il form non presenta modifiche (è pristine), chiudi
          this.store$.dispatch(TimeSlotsActions.closeTimeSlotsDialog());
        }
  }

  revert() {
    this.ngOnChanges();
  }

  deleteTimeSlot() {
    if (this.timeslots) {
      this.store$.dispatch(TimeSlotsActions.deleteTimeSlot({ timeslot: this.timeslots.toDTO() }));
    }
  }

  get _timeslots(): TimeSlots {
    return this.timeslots;
  }

  set tenant(timeslots: TimeSlots) {
    this.timeslots = timeslots;
    this.ngOnChanges();
  }

}
